<template>
  <div class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <div id="networkError-wrapper" class="card">
            <div class="title">Network Connection Error</div>
            <div class="form-wrapper">
              <div class="form-input">
                <div class="subtitle">Unable to connect to the Maprint service.</div>
                <div class="explanation">
                  This error typically occurs due to:
                  <ul>
                    <li>SSL/Certificate issues on your network</li>
                    <li>Firewall or proxy blocking the connection</li>
                    <li>Network configuration problems</li>
                  </ul>
                  <strong>You can still see your printers after the scan from another browser or device with a proper network connection.</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-link btn-space btn-link-primary full" @click="retry" :disabled="loading">
            <span v-if="!loading">{{ t ? t('Retry Connection') : 'Retry Connection' }}</span>
            <span v-else>
              <i class="fad fa-circle-notch fa-spin"></i>
              Retrying...
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */
export default {
  data () {
    return {
      loading: false
    }
  },
  methods: {
    retry () {
      console.log('[NetworkError] retry clicked')
      this.loading = true
      try { 
        window.location.reload() 
      } finally { 
        this.loading = false 
      }
    }
  }
}
</script>

<style lang="scss">
#app {
  #network-error {
    #networkError-wrapper {
      margin: 0 auto;
      color: black;
      font-family: monospace;
      width: 100%;
      .title {
        font-weight: bold;
        color: #d32f2f;
      }
      .subtitle {
        font-size: 1.25rem;
      }
      .explanation {
        font-size: 0.95rem;
        color: #666;
        margin-top: 0.5rem;
        line-height: 1.35rem;
        
        ul {
          margin: 0.75rem 0;
          padding-left: 1.5rem;
          
          li {
            margin: 0.25rem 0;
          }
        }
        
        strong {
          display: block;
          margin-top: 0.75rem;
          color: #333;
        }
      }
    }
    .modal-content {
      max-width: 36rem;
      margin: 0 auto;
      padding: 1.5rem;
      margin-top: 14vh;
      .modal-body {
        padding-top: unset;
        padding: 0;
        font-size: 1.4rem;
        .form-wrapper {
          padding: 1rem 0;
        }
      }
      .modal-footer {
        justify-content: unset;
        padding: 0;
        .btn-link {
          margin: 0 auto;
          border: 1px solid;
          font-size: 14px;
          font-weight: bold;
          text-transform: capitalize;
          width: 100%;
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/NetworkError.vue